import { styled, theme } from '@components-shared/src/stitches';

export const Indicator = styled('div', {
  position: 'absolute',
  display: 'inline-block',
  width: 8,
  height: 8,
  background: `${theme.gradients.fuchsia.value}`,
  borderRadius: '50%',
  verticalAlign: 'super',
  marginLeft: 4,
});
